export default "__VITE_ASSET__h9L3Hd03__"